import { Route } from "react-router-dom";
import PublicRoute from "./PublicRoute";
import type { RouteConfig } from "./types/index.types";
import Login from "../pages/Login/Login";
import AuthLayout from "../Layouts/AuthLayout/AuthLayout";
import DashboardLayout from "../Layouts/DashboardLayout/DashboardLayout";
import PrivateRoute from "./PrivateRoute";
import Project from "../pages/Projects/Project";

export const routes: RouteConfig[] = [
  {
    path: "/login",
    AuthGuard: PublicRoute,
    Layout: AuthLayout,
    Component: Login,
  },
  {
    path: "*",
    Layout: AuthLayout,
    AuthGuard: PublicRoute,
    Component: Login,
  },
  {
    path: "/",
    Layout: DashboardLayout,
    AuthGuard: PrivateRoute,
    Component: Project,
  },
];

export const generateRoutes = (routes: RouteConfig[]) => {
  return routes.map(
    ({ path, children, AuthGuard, Layout, Component, index }) => {
      const addLayout = () =>
        Layout ? (
          <Layout>
            <Component />
          </Layout>
        ) : (
          <Component />
        );

      return index ? (
        <Route
          key={"index"}
          index
          element={
            AuthGuard ? <AuthGuard>{addLayout()}</AuthGuard> : addLayout()
          }
        />
      ) : (
        <Route
          key={path}
          path={path}
          element={
            AuthGuard ? <AuthGuard>{addLayout()}</AuthGuard> : addLayout()
          }
        >
          {children && generateRoutes(children)}
        </Route>
      );
    }
  );
};
